import React, { useEffect, useState } from "react";
import "./MenuCategories.css";
import kanchiLogo from "../Assets/logo/KanchiLogo.png";
import Loader from "../Components/Loader/Loader";
import MenuItems from "../MenuItems/MenuItems";
import { useCart } from "../Context/CartContext";
import { useNavigate } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";

const CAFE_ID = "e7b20008-f754-402a-944c-027bf11d68c0";
const BASE_URL = "https://fliplyn-b-c.fly.dev";

const MenuCategories = () => {
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [items, setItems] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [loadingItems, setLoadingItems] = useState(false);

  const { cart } = useCart();
  const navigate = useNavigate();

  // Total quantity count
  const totalItems = Object.values(cart).reduce(
    (acc, item) => acc + item.quantity,
    0
  );

  // ✅ Fetch Categories (Hardcoded Cafe ID)
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/cafe/categories/cafe/${CAFE_ID}`
        );

        if (!res.ok) throw new Error("Failed to fetch categories");

        const data = await res.json();
        setCategories(data);

        if (data.length > 0) {
          setActiveCategory(data[0].id);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoadingCategories(false);
      }
    };

    fetchCategories();
  }, []);

  // ✅ Fetch Items by Category (Updated Endpoint with Cafe ID)
  useEffect(() => {
    if (!activeCategory) return;

    const fetchItems = async () => {
      setLoadingItems(true);
      try {
        const res = await fetch(
          `${BASE_URL}/cafe/items/${CAFE_ID}/category/${activeCategory}`
        );

        if (!res.ok) throw new Error("Failed to fetch items");

        const data = await res.json();

        const availableItems = data.filter(
          (item) => item.is_available === true
        );

        setItems(availableItems);
      } catch (error) {
        console.error("Error fetching items:", error);
      } finally {
        setLoadingItems(false);
      }
    };

    fetchItems();
  }, [activeCategory]);

  if (loadingCategories) return <Loader />;

  return (
    <>
      {/* Header */}
      <div className="menu-header">
        <img src={kanchiLogo} alt="Kanchi Cafe" className="menu-logo" />

        <div
          className="cart-icon-wrapper"
          onClick={() => navigate("/kanchi-cart")}
        >
          <FaShoppingCart className="cart-icon" />

          {totalItems > 0 && (
            <span className="cart-badge">
              {totalItems}
            </span>
          )}
        </div>
      </div>

      <div className="menu-container">
        {/* Category Tabs */}
        <div className="category-tabs">
          {categories.map((category) => (
            <button
              key={category.id}
              className={`tab-btn ${
                activeCategory === category.id ? "active" : ""
              }`}
              onClick={() => setActiveCategory(category.id)}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Items Section */}
        {loadingItems ? (
          <Loader />
        ) : (
          <MenuItems items={items} />
        )}
      </div>
    </>
  );
};

export default MenuCategories;